import React from 'react';
import { isEmptyObject, safeGet } from '../../../../../../../core/util/object';
import { getInsuranceCarrierCardDisplayProperties } from '../../../../../../../core/util/insurance';
import {
  AetnaModalValue,
  BcbsCaModalValue,
  BcbsModalValue,
  BcbsTxModalValue,
  CignaModalValue,
  UnitedModalValue,
  UniversalModalValue,
} from '../modalValues';

import AetnaAcupuncture from './AetnaAcupuncture';
import AetnaApparel from './AetnaApparel';
import AetnaChiropractor from './AetnaChiropractor';
import AetnaFluShot from './AetnaFluShot';
import AetnaGymMembership from './AetnaGymMembership';
import AetnaLasik from './AetnaLasik';
import AetnaNurseHotline from './AetnaNurseHotline';
import AetnaTherapeuticMassage from './AetnaTherapeuticMassage';
import BcbsAcupuncture from './BcbsAcupuncture';
import BcbsCaFluShot from './BcbsCaFluShot';
import BcbsChiropractor from './BcbsChiropractor';
import BcbsGarmin from './BcbsGarmin';
import BcbsGymMembership from './BcbsGymMembership';
import BcbsJennyCraig from './BcbsJennyCraig';
import BcbsLasik from './BcbsLasik';
import BcbsTherapeuticMassage from './BcbsTherapeuticMassage';
import BcbsTxFluShot from './BcbsTxFluShot';
import BcbsVitamixBlender from './BcbsVitamixBlender';
import CignaAcupuncture from './CignaAcupuncture';
import CignaChiropractor from './CignaChiropractor';
import CignaFluShot from './CignaFluShot';
import CignaGaiamYoga from './CignaGaiamYoga';
import CignaGlasses from './CignaGlasses';
import CignaGymMembership from './CignaGymMembership';
import CignaJennyCraig from './CignaJennyCraig';
import CignaPhysicalTherapy from './CignaPhysicalTherapy';
import CignaTherapeuticMassage from './CignaTherapeuticMassage';
import UnitedFluShot from './UnitedFluShot';
import UnitedGymMembership from './UnitedGymMembership';
import UnitedLasik from './UnitedLasik';
import UnitedQuitForLife from './UnitedQuitForLife';
import UniversalAnnualWellness from './UniversalAnnualWellness';
import UniversalBreastPump from './UniversalBreastPump';
import UniversalColonCancerScreening from './UniversalColonCancerScreening';
import UniversalMammogram from './UniversalMammogram';
import UniversalOsteoporosis from './UniversalOsteoporosis';
import UniversalPap from './UniversalPap';
import Default from './Default';

type Props = {
  insuranceProfile: any;
  modalValue: boolean | string;
};

const ModalContent = (props: Props) => {
  const { modalValue, insuranceProfile } = props;
  if (isEmptyObject(insuranceProfile)) return null;
  const insuranceCarrierDisplayProperties = getInsuranceCarrierCardDisplayProperties(
    insuranceProfile.insurer_code
  );
  const benefitsPhone = safeGet(insuranceCarrierDisplayProperties)('phoneNumber');

  switch (modalValue) {
    case BcbsCaModalValue.THERAPEUTIC_MASSAGE:
      return <BcbsTherapeuticMassage />;
    case BcbsCaModalValue.CHIROPRACTOR:
      return <BcbsChiropractor />;
    case BcbsCaModalValue.VITAMIX_BLENDER:
      return <BcbsVitamixBlender />;
    case BcbsCaModalValue.ACUPUNCTURE:
      return <BcbsAcupuncture />;
    case BcbsCaModalValue.GYM_MEMBERSHIP:
    case BcbsTxModalValue.GYM_MEMBERSHIP:
      return <BcbsGymMembership />;
    case BcbsCaModalValue.FLU_SHOT:
      return <BcbsCaFluShot />;
    case BcbsTxModalValue.GARMIN:
      return <BcbsGarmin />;
    case BcbsTxModalValue.JENNY_CRAIG:
      return <BcbsJennyCraig />;
    case BcbsTxModalValue.LASIK:
      return <BcbsLasik />;
    case BcbsTxModalValue.FLU_SHOT:
      return <BcbsTxFluShot />;
    case UniversalModalValue.ANNUAL_WELLNESS:
      return <UniversalAnnualWellness />;
    case UniversalModalValue.PAP:
      return <UniversalPap />;
    case UniversalModalValue.MAMMOGRAM:
      return <UniversalMammogram />;
    case UniversalModalValue.OSTEOPOROSIS:
      return <UniversalOsteoporosis />;
    case UniversalModalValue.COLON_CANCER_SCREENING:
      return <UniversalColonCancerScreening />;
    case UniversalModalValue.BREAST_PUMP:
      return (
        <UniversalBreastPump
          benefitsPhone={benefitsPhone}
          insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
          insuranceProfile={insuranceProfile}
        />
      );
    case AetnaModalValue.NURSE_HOTLINE:
      return (
        <AetnaNurseHotline
          benefitsPhone={benefitsPhone}
          insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
          insuranceProfile={insuranceProfile}
        />
      );
    case AetnaModalValue.FLU_SHOT:
      return <AetnaFluShot />;
    case AetnaModalValue.GYM_MEMBERSHIP:
      return <AetnaGymMembership />;
    case AetnaModalValue.CHIROPRACTOR:
      return <AetnaChiropractor />;
    case AetnaModalValue.ACUPUNCTURE:
      return <AetnaAcupuncture />;
    case AetnaModalValue.APPAREL:
      return <AetnaApparel />;
    case AetnaModalValue.THERAPEUTIC_MASSAGE:
      return <AetnaTherapeuticMassage />;
    case AetnaModalValue.LASIK:
    case CignaModalValue.LASIK:
      return <AetnaLasik />;
    case CignaModalValue.FLU_SHOT:
      return <CignaFluShot />;
    case CignaModalValue.GYM_MEMBERSHIP:
      return <CignaGymMembership />;
    case CignaModalValue.THERAPEUTIC_MASSAGE:
      return <CignaTherapeuticMassage />;
    case CignaModalValue.CHIROPRACTOR:
      return <CignaChiropractor />;
    case CignaModalValue.PHYSICAL_THERAPY:
      return <CignaPhysicalTherapy />;
    case CignaModalValue.JENNY_CRAIG:
      return <CignaJennyCraig />;
    case CignaModalValue.GAIAM_YOGA:
      return <CignaGaiamYoga />;
    case CignaModalValue.ACUPUNCTURE:
      return <CignaAcupuncture />;
    case CignaModalValue.GLASSES:
      return <CignaGlasses />;
    case UnitedModalValue.FLU_SHOT:
      return <UnitedFluShot />;
    case UnitedModalValue.GYM_MEMBERSHIP:
      return <UnitedGymMembership />;
    case UnitedModalValue.LASIK:
      return <UnitedLasik />;
    case UnitedModalValue.QUIT_FOR_LIFE:
      return <UnitedQuitForLife />;
    case BcbsModalValue.NURSE_HOTLINE:
    case UnitedModalValue.NURSE_HOTLINE:
    default:
      return (
        <Default
          benefitsPhone={benefitsPhone}
          insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
          insuranceProfile={insuranceProfile}
        />
      );
  }
};
export default ModalContent;
